import styled from 'styled-components';
export const Wrapper = styled.div`
  display: flex;
  padding: 10px 15px;

  justify-content: space-between;
  align-items: center;
  gap: 10px;
  position: relative;
`;
export const DescContent = styled.div`
  display: flex;
  flex-direction: column;

  width: 100px;
`;
export const Title = styled.div`
  font-weight: 600;
  font-size: 14px;
  display: inline-flex;
  color: ${({ theme }) => theme.palette.grey1100};
`;
export const Label = styled.div`
  display: inline-flex;
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 12px;
  font-weight: 400;
  opacity: 0.7;
`;
export const CounterContent = styled.div`
  display: flex;
`;
